// ui/molecules/FormField.tsx
import { Input } from "../atoms/inputs";
import { Label } from "../atoms/labels";
import { Text } from "ui/typography/Text";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FormField = ({
  label,
  error,
  ...props
}: {
  label: string;
  error?: string;
} & React.InputHTMLAttributes<HTMLInputElement>) => (
  <Wrapper>
    <Label>{label}</Label>
    <Input {...props} />
    {error && <Text variant="error">{error}</Text>}
  </Wrapper>
);
